import { observer } from 'mobx-react';
import { Format } from 'nomst/Stores/Utility/format';
import { Range } from 'nomst/Stores/Decision/range';
import { CompaRatioDisplayFormat } from 'typings/enums';
import CompViewHelper from 'sharedLogic/compViewHelper';
import * as React from 'react';
import './compaRatio.scss';

interface ICompaRatioProps {
    payRange: Range;
    payAmount: number;
    compaRatioDisplayFormat: CompaRatioDisplayFormat;
    format: Format;
    className: string;
}

export const CompaRatio = (props: ICompaRatioProps): React.ReactElement => {

    const { className, payRange, payAmount, compaRatioDisplayFormat, format } = props;
    return (
        <div className={`nomst-compa-ratio ${className}`}>
            <h3 className="nomst-compa-ratio__title">Compa Ratio</h3>
            <div className="nomst-compa-ratio__text">
                {CompViewHelper.getCompaRatio(payRange, payAmount, compaRatioDisplayFormat, format)}
            </div>
        </div>
    );
};

export default observer(CompaRatio);